import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full flex justify-center items-center h-full"
}
const _hoisted_2 = {
  key: 1,
  class: "flex flex-col gap-12"
}
const _hoisted_3 = { class: "flex flex-col gap-4" }
const _hoisted_4 = { class: "text-xl font-bold text-gray-900 px-1" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "flex flex-col gap-4"
}
const _hoisted_7 = { class: "text-xl font-bold text-gray-900 px-1" }
const _hoisted_8 = { class: "w-full" }

import { Form, SubmissionHandler } from "vee-validate";
import { computed, Ref } from "vue";
import { useI18n } from "vue-i18n";
import * as yup from "yup";
import LoadingSpinner from "shared/components/loading_state/LoadingSpinner.vue";
import {
  useDeleteLogo,
  useLogoUrl,
  useUploadLogo,
  useHasOrganizationPermission,
  useUpdateOrganizationBase,
} from "shared/composables/organization";
import { Organization, OrganizationToUpdateBase } from "shared/types/Organization";
import InputField from "@/components/forms/InputField.vue";
import LogoUpload from "@/views/settings_project/components/LogoUpload.vue";

type OrganizationForm = {
  name: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'OrganizationTabGeneral',
  props: {
    organization: {},
    organizationsByParentId: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();

const organizationId = computed(() => props.organization._id);

const hasOrganizationBasePermission = useHasOrganizationPermission(
  "organization_base",
  organizationId.value,
);
const hasOrganizationAdminPermission = useHasOrganizationPermission(
  "organization_admin",
  organizationId.value,
);

const { updateOrganization } = useUpdateOrganizationBase();
const { logoUrl, isLogoUrlFetching } = useLogoUrl(organizationId);
const { deleteLogo } = useDeleteLogo(organizationId);
const { uploadLogo } = useUploadLogo(organizationId);

const schema = yup.object({
  name: yup.string().required(t("organizations.validation_field_required")),
});

const initialValues: Ref<OrganizationForm> = computed(() => ({
  name: props.organization?.name ?? "",
}));

const handleSubmit: SubmissionHandler = async (genericObject, context) => {
  const values = genericObject as OrganizationForm;
  const payload: OrganizationToUpdateBase = {
    _id: props.organization._id,
    name: values.name,
  };
  await updateOrganization(payload)
    .then(() => context.resetForm({ values: initialValues.value }))
    .catch(() => undefined);
};

return (_ctx: any,_cache: any) => {
  return (_unref(isLogoUrlFetching))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(LoadingSpinner)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("organizations.tab_general")), 1),
          _createElementVNode("div", null, [
            _createVNode(_unref(Form), {
              onSubmit: handleSubmit,
              initialValues: initialValues.value,
              validationSchema: _unref(schema),
              class: "text-left flex flex-col gap-4"
            }, {
              default: _withCtx(({ isSubmitting, meta }) => [
                _createVNode(InputField, {
                  name: "name",
                  label: _unref(t)('organizations.organization_name'),
                  readonly: !_unref(hasOrganizationAdminPermission)
                }, null, 8, ["label", "readonly"]),
                (_unref(hasOrganizationAdminPermission))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "submit",
                      disabled: isSubmitting || !meta.dirty,
                      class: "flex items-center gap-2 rounded-md self-end w-min bg-yellow-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-yellow-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow-600 disabled:bg-gray-300 disabled:cursor-default"
                    }, [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)("buttons.save")), 1),
                      (isSubmitting && meta.valid)
                        ? (_openBlock(), _createBlock(LoadingSpinner, {
                            key: 0,
                            size: "w-4 h-4"
                          }))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_5))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["initialValues", "validationSchema"])
          ])
        ]),
        (_unref(hasOrganizationBasePermission))
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("h1", _hoisted_7, _toDisplayString(_ctx.$t("admin.general_project_settings.logo")), 1),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(LogoUpload, {
                  onUpdateFile: _cache[0] || (_cache[0] = ($event: any) => (_unref(uploadLogo)($event))),
                  onDeleteFile: _unref(deleteLogo),
                  savedLogo: _unref(logoUrl),
                  canEdit: _unref(hasOrganizationAdminPermission)
                }, null, 8, ["onDeleteFile", "savedLogo", "canEdit"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
}
}

})